/* eslint-disable @typescript-eslint/no-unused-vars */

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as Arrow } from "../assets/icons/arrow-down.svg";

import logo from "../assets/icons/cross-country.svg";

const Footer = () => {
  const navigate = useNavigate();

  const [companyLink, setCompanyLink] = useState([
    {
      to: "/about",
      open: false,
      text: "About Us",
    },
    {
      to: "/contact",
      open: false,
      text: "Contact us",
    },
    {
      to: "/terminal",
      open: false,
      text: "Terminal",
    },
    {
      to: "/nyc-camp",
      open: false,
      text: "NYSC Capm",
    },
  ]);
  const [socialLinks, setSociaLinks] = useState([
    {
      to: "https://facebook.com",
      open: false,
      text: "Facebook",
    },
    {
      to: "https://instagram.com",
      open: false,
      text: "Instagram",
    },
    {
      to: "https://linkedin.com",
      open: false,
      text: "LinkedIn",
    },
    {
      to: "https://twitter.com",
      open: false,
      text: "Twitter",
    },
  ]);
  const [contactLink, setContactLink] = useState([
    {
      to: "tel:+234-805-555-5595",
      open: false,
      text: "+234-805-555-5595",
    },
    {
      to: "tel:+234-802-846-0890",
      open: false,
      text: "+234-802-846-0890",
    },
    {
      to: "",
      open: false,
      text: "345 Muritala Muhammed Way, Opposite Presbyterian church, Yaba, Lagos.",
    },
  ]);

  const [company, setCompany] = useState(false);
  const [social, setSocial] = useState(false);
  const [contact, setContact] = useState(false);

  const toggleCompany = () => {
    setCompany(!company);
  };
  const toggleSocial = () => {
    setSocial(!social);
  };
  const toggleContact = () => {
    setContact(!contact);
  };

  return (
    <div className="bg-white">
      <div className="container mx-0 lg:mx-auto flex flex-col justify-center items-center py-10 md:py-10">
        <div className="flex flex-col lg:flex-row items-center md:items-start justify-center lg:justify-between w-full px-4 md:px-32 lg:px-20 pt-12 md:pt-28 gap-0 md:gap-2 ">
          <div className="flex flex-col justify-center items-start gap-3 md:gap-6 lg:w-[50%]">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
            <div className="text-[14px] md:text-base lg:text-base text-start text-black leading-6 md:leading-9">
              Cross Country is a transportation company that is located in Yaba,
              Lagos. The company serves more than 26 destinations in Nigeria and
              some neighboring African.
            </div>
          </div>
          <div className="flex flex-col w-full justify-start items-start md:hidden pt-14 gap-8">
            <div className="flex flex-col w-full">
              <div
                className="flex justify-between items-center"
                onClick={() => toggleCompany()}
              >
                <div className=" text-pry font-medium text-base">Company</div>
                <Arrow className={`${!company ? "" : "rotate-180"}`} />
              </div>
              <div className={`${company ? "block" : "hidden"}`}>
                {companyLink.map((item) => (
                  <div
                    className="text-black font-normal text-base mt-6"
                    key={item.text}
                  >
                    <Link to={item.to}>{item.text}</Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div
                className="flex justify-between items-center"
                onClick={() => toggleSocial()}
              >
                <div className=" text-pry font-medium text-base">Social</div>
                <Arrow className={`${!social ? "" : "rotate-180"}`} />
              </div>
              <div className={`${social ? "block" : "hidden"}`}>
                {socialLinks.map((item) => (
                  <div
                    className="text-black font-normal text-base mt-6"
                    key={item.text}
                  >
                    <a href={item.to}>{item.text}</a>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col w-full">
              <div
                className="flex justify-between items-center"
                onClick={() => toggleContact()}
              >
                <div className=" text-pry font-medium text-base">Contact</div>
                <Arrow className={`${!contact ? "" : "rotate-180"}`} />
              </div>
              <div className={`${contact ? "block w-40" : "hidden"}`}>
                {contactLink.map((item) => (
                  <div
                    className="text-black font-normal text-base mt-6"
                    key={item.text}
                  >
                    <a href={item.to}>{item.text}</a>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="hidden md:flex flex-col md:flex-row justify-evenly items-start w-full gap-3">
            <div className="flex flex-col justify-center items-start">
              <div className="font-medium text-pry text-[22px] ">COMPANY</div>
              <div>
                {companyLink.map((item) => (
                  <div className="text-black mt-4" key={item.to}>
                    <Link to={item.to}>{item.text}</Link>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col justify-center items-start">
              <div className="font-medium text-pry text-[22px] ">SOCIAL</div>
              <div>
                {socialLinks.map((item) => (
                  <div className="text-black mt-4" key={item.to}>
                    <a href={item.to}>{item.text}</a>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col justify-center items-start w-[30%]">
              <div className="font-medium text-pry text-[22px] ">Contact</div>
              <div>
                {contactLink.map((item) => (
                  <div className="text-black mt-4" key={item.to}>
                    <a href={item.to}>{item.text}</a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="font-medium text-pry text-[15px]  mt-20">
          © 2023 All Rights Reserved.
          <span className="underline ">Terms of Carriage</span>.
        </div>
      </div>
    </div>
  );
};

export default Footer;
